import { makeStyles, tokens } from '@coreai/fluentui-react';
import { customScrollbarStyles } from '@/styles/scrollbar';

export const useRecurrenceFieldStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  row: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: tokens.spacingHorizontalM,
  },
  frequencyField: {
    flex: '1 1 auto',
    minWidth: '120px',
  },
  intervalField: {
    flex: '0 0 100px',
    fontVariantNumeric: 'tabular-nums',
  },
  unitLabel: {
    paddingBottom: tokens.spacingVerticalS,
    color: tokens.colorNeutralForeground2,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  preview: {
    backgroundColor: tokens.colorNeutralBackground3,
    padding: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusMedium,
    marginTop: tokens.spacingVerticalS,
  },
  previewText: {
    color: tokens.colorNeutralForeground2,
    fontStyle: 'italic',
    textWrap: 'pretty',
  },
  advancedSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalS,
  },
  scheduleSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalS,
  },
  weekDaysContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalS,
  },
  tagsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  tagsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalXS,
    alignItems: 'center',
  },
  inputRow: {
    display: 'flex',
    gap: tokens.spacingHorizontalXS,
    alignItems: 'center',
  },
  addButton: {
    minWidth: 'auto',
  },
  numberInput: {
    flex: '1 1 auto',
    minWidth: '80px',
  },
  error: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
  },
  inlineCode: {
    backgroundColor: tokens.colorNeutralBackground4,
    color: tokens.colorNeutralForeground1,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    borderRadius: tokens.borderRadiusSmall,
    fontFamily: tokens.fontFamilyMonospace,
  },
  timezoneListbox: {
    maxHeight: '300px',
    overflowY: 'auto',
    ...customScrollbarStyles,
  },
  dayToggle: {
    minWidth: '36px',
    height: '36px',
    borderRadius: tokens.borderRadiusCircular,
    padding: 0,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
    transitionProperty: 'transform, background-color, border-color',
    transitionDuration: tokens.durationFaster,
    transitionTimingFunction: tokens.curveDecelerateMin,
    ':active': {
      transform: 'scale(0.96)',
    },
  },
  warningBar: {
    whiteSpace: 'normal',
  },
  warningBarBody: {
    whiteSpace: 'normal',
  },
  scheduleDivider: {
    color: tokens.colorNeutralForeground3,
    paddingTop: tokens.spacingVerticalS,
  },
});
